import { service } from '@ember/service';
import Controller from '@ember/controller';
import appointmentWasCreated from 'client-portal/utils/appointment-was-created';

export default class RequestConfirmationController extends Controller {
  @service currentPractice;
  @service session;

  get loggedIn() {
    return this.session.isAuthenticated;
  }

  get appointmentWasCreated() {
    return appointmentWasCreated(this.model?.appointment);
  }

  get useBookAppointmentLanguage() {
    return Boolean(this.currentPractice.get('useBookAppointmentLanguage'));
  }

  get showBookConfirmation() {
    return this.useBookAppointmentLanguage && this.appointmentWasCreated;
  }

  get showDuplicateBookConfirmation() {
    return this.useBookAppointmentLanguage && !this.appointmentWasCreated;
  }

  get confirmationMessageKey() {
    if (this.showBookConfirmation) {
      return 'confirmation.thankYou.appointmentBooked';
    }
    if (this.showDuplicateBookConfirmation) {
      return 'confirmation.thankYou.checkEmailForNextSteps';
    }
    return 'confirmation.thankYou.appointmentRequested';
  }

  get confirmationSubmessageKey() {
    if (this.showBookConfirmation) {
      return null;
    }
    if (this.showDuplicateBookConfirmation) {
      return 'confirmation.thankYou.checkEmailForNextStepsSubmessage';
    }
    return 'confirmation.thankYou.appointmentRequestedSubmessage';
  }
}
